var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.907 17.046c.574.055 1.087-.366 1.093-.941a12 12 0 1 0-1.558 5.809c.284-.502.049-1.123-.475-1.362-.524-.24-1.137-.005-1.43.49a9.915 9.915 0 1 1 1.378-5.137c.005.576.42 1.086.992 1.14Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.953 13.416c.576 0 1.043.467 1.043 1.044v6.934a1.043 1.043 0 1 1-2.087 0V14.46c0-.577.467-1.044 1.044-1.044Z",
    fill: "#102B3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.996 11.33a1.043 1.043 0 1 1-2.087 0 1.043 1.043 0 0 1 2.087 0Z",
    fill: "#102B3F"
  })));
};
export default SvgInfo;